/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Regenerate_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo writes the report again from all the material, keeping what you changed in the text yourself. Your action points stay." |
*
* @param {Meeting_Report_Regenerate_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_regenerate_body = /** @type {((inputs?: Meeting_Report_Regenerate_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Regenerate_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft het verslag opnieuw uit al het materiaal, en neemt wat je zelf in de tekst aanpaste mee. Je actiepunten blijven staan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo réécrit le compte rendu à partir de toutes les sources, en gardant ce que vous avez modifié vous-même dans le texte. Vos points d'action restent.")
	return /** @type {LocalizedString} */ ("Wundo writes the report again from all the material, keeping what you changed in the text yourself. Your action points stay.")
});